import i18n from './index';

/** Strings for "Import from Miro", merged into the main bundles (keys `importMiro.*`, `errors.*`). */
const ru = {
  importMiro: {
    signIn: 'Войти через Miro',
    orToken: 'или вставьте токен доступа',
    open: 'Импорт из Miro',
    title: 'Импорт из Miro',
    subtitle: 'Перенесите доску из Miro со стикерами, фигурами, текстом, фреймами, картинками и связями.',
    tokenLabel: 'Токен доступа Miro',
    showToken: 'Показать токен',
    hideToken: 'Скрыть токен',
    howTo: 'Как получить токен',
    steps: [
      'В Miro откройте Settings → Your apps и нажмите Create new app (или на developers.miro.com).',
      'В разделе Permissions включите boards:read.',
      'Нажмите Install app and get OAuth token и выберите команду, где лежат доски.',
      'Скопируйте токен и вставьте его в поле ниже.',
    ],
    privacy: 'Токен нужен только на время импорта и нигде не сохраняется.',
    connect: 'Показать доски',
    chooseBoard: 'Доска в Miro',
    searchBoards: 'Поиск по названию',
    noBoards: 'У этого токена нет доступа ни к одной доске.',
    nothingFound: 'Ничего не найдено',
    edited: 'изменена {{time}}',
    changeToken: 'Другой токен',
    targetTeam: 'Куда в Ватмане',
    noProject: 'Без проекта',
    start: 'Импортировать',
    phases: {
      board: 'Подключаемся к доске…',
      items: 'Загружаем объекты: {{done}} из {{total}}',
      connectors: 'Загружаем связи: {{done}} из {{total}}',
      images: 'Переносим картинки: {{done}} из {{total}}',
      saving: 'Сохраняем доску…',
      done: 'Готово',
    },
    background: 'Окно можно закрыть: импорт продолжится, а доска появится в списке.',
    doneTitle: 'Доска «{{title}}» готова',
    imported: 'Перенесено объектов: {{count}}',
    skippedTitle: 'Не перенесено',
    warningsTitle: 'Перенесено с упрощениями',
    openBoard: 'Открыть доску',
    another: 'Импортировать ещё',
    failedTitle: 'Импорт не удался',
    retry: 'Попробовать снова',
    types: {
      sticky_note: 'Стикеры',
      shape: 'Фигуры',
      text: 'Текст',
      frame: 'Фреймы',
      card: 'Карточки',
      app_card: 'Карточки приложений',
      image: 'Картинки',
      connector: 'Связи',
      embed: 'Встроенный контент',
      document: 'Документы',
      preview: 'Превью ссылок',
      mindmap_node: 'Узлы mind map',
      table: 'Таблицы',
      kanban: 'Канбан',
      usm: 'Карты пользовательских историй',
      prototyping_screen: 'Экраны прототипов',
      doc_format: 'Документы Miro',
      data_table_format: 'Таблицы данных',
      unknown: 'Неизвестные объекты',
    },
    reasons: {
      unsupported_type: 'пока не поддерживается',
      missing_endpoint: 'не к чему прикрепить',
      download_failed: 'не удалось скачать',
      unsupported_image_format: 'формат не поддерживается',
      image_too_large: 'файл больше 25 МБ',
      upload_failed: 'не удалось сохранить',
      no_image_url: 'нет файла',
      too_many_items: 'больше 20 000 объектов',
      shape_approximated: 'форма заменена похожей',
      rotation_ignored: 'без поворота',
      end_detached: 'конец не прикреплён',
      cap_approximated: 'наконечник заменён похожим',
    },
  },
  errors: {
    miro_connection_expired: 'Вход в Miro устарел — войдите ещё раз',
    miro_oauth_off: 'Вход через Miro не настроен',
    miro_oauth_denied: 'Доступ к Miro не дали',
    miro_oauth_failed: 'Не получилось войти в Miro — попробуйте ещё раз',
    miro_token_invalid: 'Miro не принял токен. Проверьте, что он скопирован целиком и не отозван.',
    miro_forbidden: 'У токена нет доступа: нужно разрешение boards:read и доступ к команде с этой доской.',
    miro_board_not_found: 'Доска не найдена в Miro.',
    miro_rate_limited: 'Miro просит подождать. Попробуйте через минуту.',
    miro_unavailable: 'Miro сейчас недоступен. Попробуйте позже.',
    import_running: 'Уже идут два импорта. Дождитесь, пока они закончатся.',
    invalid_project: 'Проект не найден в выбранной команде.',
  },
};

const en: typeof ru = {
  importMiro: {
    signIn: 'Sign in to Miro',
    orToken: 'or paste an access token',
    open: 'Import from Miro',
    title: 'Import from Miro',
    subtitle: 'Bring a Miro board over with its stickies, shapes, text, frames, images and connectors.',
    tokenLabel: 'Miro access token',
    showToken: 'Show token',
    hideToken: 'Hide token',
    howTo: 'How to get a token',
    steps: [
      'In Miro, open Settings → Your apps and click Create new app (or use developers.miro.com).',
      'Under Permissions, enable boards:read.',
      'Click Install app and get OAuth token and pick the team that has your boards.',
      'Copy the token and paste it below.',
    ],
    privacy: 'The token is used only during the import and is never stored.',
    connect: 'Show boards',
    chooseBoard: 'Miro board',
    searchBoards: 'Search by name',
    noBoards: 'This token has no access to any boards.',
    nothingFound: 'Nothing found',
    edited: 'edited {{time}}',
    changeToken: 'Use another token',
    targetTeam: 'Where in Vatman',
    noProject: 'No project',
    start: 'Import',
    phases: {
      board: 'Connecting to the board…',
      items: 'Loading items: {{done}} of {{total}}',
      connectors: 'Loading connectors: {{done}} of {{total}}',
      images: 'Copying images: {{done}} of {{total}}',
      saving: 'Saving the board…',
      done: 'Done',
    },
    background: 'You can close this window: the import keeps going and the board will show up in your list.',
    doneTitle: '“{{title}}” is ready',
    imported: 'Items imported: {{count}}',
    skippedTitle: 'Not imported',
    warningsTitle: 'Imported with simplifications',
    openBoard: 'Open board',
    another: 'Import another',
    failedTitle: 'Import failed',
    retry: 'Try again',
    types: {
      sticky_note: 'Stickies',
      shape: 'Shapes',
      text: 'Text',
      frame: 'Frames',
      card: 'Cards',
      app_card: 'App cards',
      image: 'Images',
      connector: 'Connectors',
      embed: 'Embeds',
      document: 'Documents',
      preview: 'Link previews',
      mindmap_node: 'Mind map nodes',
      table: 'Tables',
      kanban: 'Kanban',
      usm: 'User story maps',
      prototyping_screen: 'Prototype screens',
      doc_format: 'Miro Docs',
      data_table_format: 'Data tables',
      unknown: 'Unknown items',
    },
    reasons: {
      unsupported_type: 'not supported yet',
      missing_endpoint: 'nothing to attach to',
      download_failed: "couldn't download",
      unsupported_image_format: 'format not supported',
      image_too_large: 'file is over 25 MB',
      upload_failed: "couldn't save",
      no_image_url: 'no file',
      too_many_items: 'over 20,000 items',
      shape_approximated: 'shape replaced with a similar one',
      rotation_ignored: 'rotation dropped',
      end_detached: 'end left unattached',
      cap_approximated: 'arrowhead replaced with a similar one',
    },
  },
  errors: {
    miro_connection_expired: 'The Miro sign-in expired — sign in again',
    miro_oauth_off: 'Signing in to Miro is not set up',
    miro_oauth_denied: 'Access to Miro was not granted',
    miro_oauth_failed: 'Could not sign in to Miro — try again',
    miro_token_invalid: "Miro didn't accept the token. Check that it was copied in full and hasn't been revoked.",
    miro_forbidden: 'The token has no access: it needs the boards:read permission and access to the team with this board.',
    miro_board_not_found: 'Board not found in Miro.',
    miro_rate_limited: 'Miro asks to slow down. Try again in a minute.',
    miro_unavailable: 'Miro is unavailable right now. Try again later.',
    import_running: 'Two imports are already running. Wait for them to finish.',
    invalid_project: "This project isn't in the selected team.",
  },
};

i18n.addResourceBundle('ru', 'translation', ru, true, false);
i18n.addResourceBundle('en', 'translation', en, true, false);
